import React from 'react'
import { connect } from 'react-redux'
import { VStack, Divider, MenuDivider } from '@chakra-ui/react'
import { switchToAdmin } from 'redux/actions/admin.actions'
import { logout } from 'redux/actions/user.actions'

import { IconAddon, IconPrice, IconAdjustments, IconHelp, IconCash, IconUser, IconLogout } from '_base/Icon'

import DrawerItem from '_components/DrawerItem'
import MenuItem from '_components/MenuItem'

function Menu({ isAccountActive, isAdmin, switchToAdmin, logout }) {
  return (
    <>
      <MenuItem icon={IconAdjustments} to="/account">
        Manage
      </MenuItem>
      <MenuItem icon={IconHelp} href="https://help.ranktracker.com/en/">
        Help
      </MenuItem>
      <MenuItem icon={IconPrice} to="/plans" show={!isAccountActive}>
        Pricing
      </MenuItem>
      <MenuItem icon={IconAddon} to="/addons" show={!isAccountActive}>
        Addons
      </MenuItem>
      <MenuItem icon={IconCash} href="https://www.ranktracker.com/affiliate-program/">
        Affiliate Program
      </MenuItem>
      <MenuItem icon={IconUser} onClick={switchToAdmin} show={isAdmin}>
        Switch to Admin
      </MenuItem>
      <MenuDivider />
      <MenuItem icon={IconLogout} onClick={logout}>
        Logout
      </MenuItem>
    </>
  )
}

function Drawer({ isAccountActive, isAdmin, switchToAdmin, logout }) {
  return (
    <VStack align="start" mt="2">
      <DrawerItem icon={IconAdjustments} to="/account">
        Manage
      </DrawerItem>
      <DrawerItem icon={IconHelp} href="https://help.ranktracker.com/en/">
        Help
      </DrawerItem>
      <DrawerItem icon={IconPrice} to="/plans" show={!isAccountActive}>
        Pricing
      </DrawerItem>
      <DrawerItem icon={IconAddon} to="/addons" show={!isAccountActive}>
        Addons
      </DrawerItem>
      <DrawerItem icon={IconCash} href="https://www.ranktracker.com/affiliate-program/">
        Affiliate Program
      </DrawerItem>
      <DrawerItem icon={IconUser} onClick={switchToAdmin} show={isAdmin}>
        Switch to Admin
      </DrawerItem>
      <Divider />
      <DrawerItem icon={IconLogout} onClick={logout}>
        Logout
      </DrawerItem>
    </VStack>
  )
}

function AccountContent({ type, ...rest }) {
  if (type === 'menu') {
    return <Menu {...rest} />
  }
  return <Drawer {...rest} />
}

const mapStateToProps = state => {
  return {
    isAdmin: !!localStorage.getItem('admin-jwt'),
    isAccountActive: state.account?.data?.plan?.status === 'active'
  }
}

export default connect(mapStateToProps, {
  switchToAdmin,
  logout
})(AccountContent)
